module.exports = __webpack_public_path__ + "img/Priest-nightelf-m-70.6a03c76b.gif";